import { css } from '@/styled-system/css';

export const overflowParagraphStyles = css.raw({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  width: { base: '150px', lg: '200px' },
});
